<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Notícias">
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
              <!--
                <b-form-group>
                    <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
                    
              </b-form-group>
              -->
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Nova Notícia</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
              
  
          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
            
            <b-col cols="auto"> 
            <b-form-group>
                <label for="name">Público</label>
                <b-form-select id="public"
                  v-model="filters.public"
                  :plain="true"
                  :options="publicddl"
                  :value="[null,'c']">
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="name">Status</label>
                  <b-form-select id="status"
                    v-model="filters.status"
                    :plain="true"
                    :options="statusddl"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        

            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped

                >

                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>

                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="primary"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            <!--
                              <b-button size="sm" variant="primary"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-file-pdf-o"></i></b-button>
                            -->
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                        
                      <b-row v-show="row.item.bodyText && row.item.bodyText.length > 0">
                            <b-col class="small">Conteúdo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.bodyText }}</b-col>
                        </b-row>
                     
                        <b-row>
                            <b-col>
                            <hr> 
                            <p><i>Publicado em <b>{{ row.item.publishedIn }}</b> por <b>{{ row.item.publisherName }}</b></i></p>
                            <p></p>
                            <p><a :href="row.item.url" target="_blank">{{ row.item.url }}</a></p>
                            </b-col>
                        </b-row>
                    </b-card>
                </template>
                
                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatusClick(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>

                <template v-slot:cell(name)="data">
                     <p>{{ data.item.name  }}<br>
                      <span class="text-primary">{{ data.item.summary }}</span>
                    </p>
                     
                </template>
                
                <template v-slot:cell(isPublic)="data">
                    <c-switch class="" @change.native="changePublicClick(data.item)" color="primary" :checked="data.item.isPublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>


        </b-card-body>
     </b-card>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Notícia"
              size="lg">
  
        <b-form @submit.stop.prevent="onSubmit">
  
        <div class="animated fadeIn">
      
         
          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Título"
                label-for="name"
                :label-cols="3"
                :horizontal="true">
                <b-form-textarea
                  id="textarea"
                  v-model="selectedItem.name"
                  placeholder=""
                  rows="3"
                ></b-form-textarea>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
  
          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Resumo"
                label-for="summary"
                :label-cols="3"
                :horizontal="true">
                <b-form-textarea
                  id="textarea"
                  v-model="selectedItem.summary"
                  placeholder=""
                  rows="3"
                ></b-form-textarea>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Conteúdo"
                label-for="bodyText"
                :label-cols="3"
                :horizontal="true">
                <quill-editor v-model="selectedItem.bodyText" :content="selectedItem.bodyText" :options="editorMessageOptions"></quill-editor>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>

        
  
          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Publicado por"
                label-for="publisherName"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.publisherName" id="publisherName" type="text"></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group label="Publicado em" 
                description=""
                label-for="publishedIn"
                :label-cols="3"
                :horizontal="true"
              >
                <b-input-group>
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class='fa fa-calendar'></i>
                    </span>
                  </div>
                  <masked-input
                    type="tel"
                    name="publishedIn"
                    class="form-control"
                    v-model="selectedItem.publishedIn"
                    :mask="[/[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, ':', /[0-9]/, /[0-9]/  ]"
                    :guide="true"     
                    
                    >
                  </masked-input>
                </b-input-group>

                <!--
                <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="[1]">
                  <b-form-checkbox :value="selectedUser.phoneExtPublic">Exibir no portal</b-form-checkbox>              
                </b-form-checkbox-group>
                -->

              </b-form-group>
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group label="Publicar até" 
                description=""
                label-for="publishUntil"
                :label-cols="3"
                :horizontal="true"
              >
                <b-input-group>
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class='fa fa-calendar'></i>
                    </span>
                  </div>
                  <masked-input
                    type="tel"
                    name="publishUntil"
                    class="form-control"
                    v-model="selectedItem.publishUntil"
                    :mask="[/[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, ':', /[0-9]/, /[0-9]/  ]"
                    :guide="true"     
                    
                    >
                  </masked-input>
                </b-input-group>

                <!--
                <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="[1]">
                  <b-form-checkbox :value="selectedUser.phoneExtPublic">Exibir no portal</b-form-checkbox>              
                </b-form-checkbox-group>
                -->

              </b-form-group>
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Localização"
                label-for="location"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.location" id="location" type="text"></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
  
          
          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="URL"
                label-for="url"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.url" id="url" type="text"></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-form>
                <b-form-group
                description=""
                label="Cor/Classe"
                label-for="color"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.color" id="color" type="text"></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>
  




          <b-input-group class="mb-4">
              <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
          </b-input-group>
        
          <div slot="footer" class="text-right">
            <!--
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
            <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
            -->
            <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Notícia</span></b-button>
           
          </div>
                
        </div>
        </b-form>
  
      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";

  import { Switch as cSwitch } from '@coreui/vue'
  
  
/*
Máscara
*/
import MaskedInput from 'vue-text-mask'
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
import { setupCalendar, DatePicker } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'


  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', summary: '', bodyText: '', color: 'list-group-item-accent-primary', publisherName: '', publishedIn: '', url: '', location: 'São Paulo', isPublic: 0, publishUntil: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      MaskedInput,
      cSwitch
    },
    data: () => {
      return {
        companyDDL: [],
        editorMessageOptions: {
              placeholder: '',
              readonly: false
            },
        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },

        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          companyId: 0,
          key: '',
          public: -1,
          status: 0
        },

        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",

        selectedItem: newItem,
        items: [
          {id: 1, st: 'A', title: 'Compras', summary: 'Informática/TI', enddate: "2022-01-29", publishedin: '2022-01-29 12:21:11', publisher: 'Equipe A6i', icon: 'img/document.png', isPublic: 0, url: 'http://www.google.com', _rowVariant: 'none'},
        ],
        fields: [
          {key: 'show_details', label: "", thStyle: { width: "50px" } },
          //{key: 'id' },
          {key: 'name', label: 'Título', sortable: true },
          {key: 'publishUntil', label: 'Publicar até', sortable: true, thStyle: { width: "150px" } },
          {key: 'isPublic', label: 'Público', sortable: true, thStyle: { width: "40px" } },
          {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
        ],
        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
        publicddl: [
          {
            text: '- Todos -',
            value: -1
          },
          {
            text: 'Público',
            value: "1"
          },
          {
            text: 'Privado',
            value: "0"
          }
        ],
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return (this.filters.key == '' || item.title.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
              && (this.filters.public == -1 || this.filters.public == item.isPublic)
              && (this.filters.status == 0 || this.filters.status == item.st)
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {
      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     
      changeStatusClick(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';

          this.saveItem(item);
        }
      },
      changePublicClick(item) {
        if(item != null) {
          if(item.isPublic == '1') 
            item.isPublic = false; 
          else 
            item.isPublic = true;

          this.saveItem(item);
        }
      },
      async saveItem(item) {
        var s = this
        var currentUser = this.$store.state.currentUser;
        s.saveEnabled = false

        item['st']='A'
        item['companyId'] = this.$store.state.config.companyId
        item['uid'] = currentUser.id
        item['sid'] = currentUser.sid

        await axios.post(
            this.$store.state.ws_url + "/portalnews",
            item
        ).then(function(resp) {
          s.saveEnabled = true;
          s.editModal = false;
          s.refreshData();

          toast ({
            type: VueNotifications.types.success,
            title: 'Notícia',
            message: 'Notícia salva com sucesso.',
            timeout: 5000
          })
        }).catch(function(error) {
          console.log(error)
        })

      },
      save() {
        this.saveItem(this.selectedItem);
      },
      enableDisable() {
        console.log('Habilitando/desabilitando notícia')
        console.log(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        if(item == null) {
            this.selectedItem = newItem;      
            this.selectedItem['companyId'] = this.$store.state.config.companyId
        }
        else {
            this.selectedItem = { ...item }  // JSON.parse(JSON.stringify(item));
        }
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items
        //console.log(items);
        //this.openEditModal(items[0])
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
          if(!this.tableSelectable) {
            console.log(item);
            this.clearSelectedRows();            
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      toggleBusy() {
        this.isBusy = !this.isBusy
      },
      async refreshData() {
        var s = this;
        var currentUser = this.$store.state.currentUser
        this.isBusy
        await axios.get(
            this.$store.state.ws_url + "/portalnews?companyId=1&uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(function(resp) {
          s.items = resp.data.obj;    
        }).catch(function(error) {
          console.log(error)
        })
          
      }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId
      this.refreshData();
    }
  }
  </script>
  
<style scoped>
table#table-transition-example .flip-list-move {
  transition: transform 1s;
}
</style>